import { Stabilizer, Stabilizers } from 'module/Redux';
import { RouterSelector } from 'module/Redux/Router';
import { MainAction } from './MainAction';

const createTouchStabilizer = (): Stabilizer => {
  let cache: string = '';
  return state => {
    const route = RouterSelector.selectRoute(state);
    if (route !== cache) {
      cache = route;
      if (state.touch !== state.touchDetected && state.touchDetected !== undefined) {
        return MainAction.updateTouch(state.touchDetected);
      }
    }
    return null;
  };
};

export const stabilizers: Stabilizers = [createTouchStabilizer()];



// WEBPACK FOOTER //
// ./src/module/Redux/Main/stabilizer.ts